import { yup } from '@framework/validation/initYup.ts';
import {
  ComputeExpressionSchema,
  ComputeStringExpressionSchema,
} from '../../../../expressions/compute/validation/ComputeExpressionSchema.ts';
import { Datatype } from '../../../../expressions/datatype/Datatype.ts';
import { WidgetType } from '../../../Widget.ts';
import { CommonInputWidgetConfigSchema } from '../../inputs/common/CommonInputConfigComponent.tsx';
import { type IPaymentRowWidget } from './IPaymentRowWidget.ts';

export function PaymentRowWidgetFieldConfigSchema(datatype: Datatype) {
  // Distinguiamo tra le espressioni stringa (e.g. descrizione) e numeriche (e.g. IVA)
  // Anche se poi comunque il risultato è sempre una stringa, in questo modo possiamo
  // configurare le espressioni stringa con caratteri speciali, come le virgole.
  const expressionSchema =
    datatype === Datatype.String
      ? ComputeStringExpressionSchema
      : ComputeExpressionSchema;
  return yup
    .object({
      editable: yup.boolean().default(true).required(),
      expression: expressionSchema
        .label('Espressione')
        .when('editable', ([editable]: boolean[], schema: any) => {
          return editable ? yup.mixed().notRequired().strip() : schema;
        }),
    })
    .required()
    .noUnknown();
}

export const PaymentRowConfigSchema: yup.ObjectSchema<IPaymentRowWidget> =
  CommonInputWidgetConfigSchema.shape({
    type: yup.string().exact(WidgetType.PaymentRow).required(),
    description: PaymentRowWidgetFieldConfigSchema(Datatype.String),
    baseUnitAmount: PaymentRowWidgetFieldConfigSchema(Datatype.Number),
    quantity: PaymentRowWidgetFieldConfigSchema(Datatype.Number),
    unit: PaymentRowWidgetFieldConfigSchema(Datatype.String),
    vat: PaymentRowWidgetFieldConfigSchema(Datatype.Number),
    discount: PaymentRowWidgetFieldConfigSchema(Datatype.Number),
    canBeExcluded: yup.boolean().default(true),
    showReport: yup.boolean().default(true),
  })
    .required()
    .noUnknown();
